import { Box, Typography } from "@mui/material";

const PageTitle = ({ subtitle, title }: { subtitle: string; title: string }) => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3">{title}</Typography>
      <Typography variant="body1">{subtitle}</Typography>
    </Box>
  );
};

export default PageTitle;
